export enum SimilaritiesActionsEnum {
  SIMILARITIES_INIT_PAGE = 'SIMILARITIES_INIT_PAGE',
  SIMILARITIES_GET_DATA = 'SIMILARITIES_GET_DATA',
  SIMILARITIES_SET_DATA = 'SIMILARITIES_SET_DATA',
  SIMILARITIES_SET_ORDER = 'SIMILARITIES_SET_ORDER',
  SIMILARITIES_GET_DATA_NEXT_PAGE = 'SIMILARITIES_GET_DATA_NEXT_PAGE',
  SIMILARITIES_SET_SEARCH_STRING = 'SIMILARITIES_SET_SEARCH_STRING',
  SIMILARITIES_SET_FILTER = 'SIMILARITIES_SET_FILTER',
  SIMILARITIES_CHANGE_STATUS = 'SIMILARITIES_CHANGE_STATUS',
  SIMILARITIES_EXPORT_LIST = 'SIMILARITIES_EXPORT_LIST',
  SIMILARITIES_GET_DATA_BY_ID = 'SIMILARITIES_GET_DATA_BY_ID',
  SIMILARITIES_SET_DATA_BY_ID = 'SIMILARITIES_SET_DATA_BY_ID',
  SIMILARITIES_SET_ORDER_BY_ID = 'SIMILARITIES_SET_ORDER_BY_ID',
  SIMILARITIES_SET_FILTER_BY_ID = 'SIMILARITIES_SET_FILTER_BY_ID',
  SIMILARITIES_SET_PERSON_ID = 'SIMILARITIES_SET_PERSON_ID',
  SIMILARITIES_EXPORT_BY_ID = 'SIMILARITIES_EXPORT_BY_ID',
  SIMILARITIES_GET_FETCH_SETTING_BY_CODE = 'SIMILARITIES_GET_FETCH_SETTING_BY_CODE',
  SIMILARITIES_SET_FETCH_SETTING_BY_CODE = 'SIMILARITIES_SET_FETCH_SETTING_BY_CODE',
}
